import { Store } from '@/core/flux.service';
import type { PersistenceLevel } from '@/core/flux.service';

interface WorkbenchLayoutState {
  layoutLocked: boolean;
}

type WorkbenchLayoutDehydratedState = WorkbenchLayoutState;

/**
 * This store manages the pieces of the layout data that apply WORKBENCH-level wide.
 */
export class WorkbenchLayoutStore extends Store {
  persistenceLevel: PersistenceLevel = 'WORKBENCH';
  static readonly storeName = 'sqWorkbenchLayoutStore';

  initialize() {
    const initialState: WorkbenchLayoutState = {
      layoutLocked: false,
    };
    this.state = this.immutable(initialState);
  }

  get layoutLocked(): boolean {
    return this.state.get('layoutLocked');
  }

  dehydrate(): WorkbenchLayoutDehydratedState {
    return this.state.serialize();
  }

  rehydrate(dehydratedState: Partial<WorkbenchLayoutDehydratedState>): void {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    LAYOUT_SET_LAYOUT_LOCKED: ({ locked }: { locked: boolean }) => {
      this.state.set('layoutLocked', locked);
    },
  };
}
